import type { CookiePreferences } from '@global/types/cookie-consent';

export const getCookie = (name: string): string | null => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop()?.split(';').shift() || null;
  }
  return null;
};

export const setCookie = (
  name: string,
  value: string,
  maxAge: number = 31536000 // 1 year default
): void => {
  document.cookie = `${name}=${value}; max-age=${maxAge}; path=/; SameSite=Lax`;
};

export const deleteCookie = (name: string): void => {
  document.cookie = `${name}=; max-age=0; path=/;`;
};

export const getCookiePreferences = (): CookiePreferences | null => {
  const cookie = getCookie('cookie_prefs_web_wallet');
  if (!cookie) return null;

  try {
    return JSON.parse(cookie) as CookiePreferences;
  } catch (error) {
    console.error('Error parsing cookie preferences:', error);
    return null;
  }
};

export const saveCookiePreferences = (prefs: CookiePreferences): void => {
  setCookie('cookie_prefs_web_wallet', JSON.stringify(prefs));
};

// Flag to track if unauthenticated user preferences need backend sync after login
const COOKIE_PREFS_SYNC_FLAG = 'cookiePreferences_needsSync';

export const markPreferencesForSync = (): void => {
  localStorage.setItem(COOKIE_PREFS_SYNC_FLAG, 'true');
};

export const getPendingSyncPreferences = (): CookiePreferences | null => {
  const needsSync = localStorage.getItem(COOKIE_PREFS_SYNC_FLAG);
  if (needsSync !== 'true') return null;
  return getCookiePreferences();
};

export const clearSyncFlag = (): void => {
  localStorage.removeItem(COOKIE_PREFS_SYNC_FLAG);
};
